import Image, { StaticImageData } from "next/image";
import { Org, getOrg } from "utils/site";
import DeutscheBank from "../../../../../assets/images/bank-deutsche-bank.png";
import Handelsbanken from "../../../../../assets/images/bank-handelsbanken.png";
import Nordea from "../../../../../assets/images/bank-nordea.png";
import Postbank from "../../../../../assets/images/bank-postbank.png";
import SEB from "../../../../../assets/images/bank-seb.png";
import Sparkasse from "../../../../../assets/images/bank-sparkasse.png";
import Swedbank from "../../../../../assets/images/bank-swedbank.png";
import Volksbank from "../../../../../assets/images/bank-volksbank.png";
import { FlexRow } from "ui-kit/Layout/Flex";
import { Typography } from "ui-kit/Typography";
import { useWebTranslation } from "translations";
import Gutter from "ui-kit/Gutter";

const bankLogos: Record<Org, { src: StaticImageData; alt: string }[]> = {
  swe: [
    { src: Handelsbanken, alt: "Handelsbanken" },
    { src: Nordea, alt: "Nordea" },
    { src: SEB, alt: "SEB" },
    { src: Swedbank, alt: "Swedbank" },
  ],
  ger: [
    { src: Sparkasse, alt: "Sparkasse" },
    { src: Volksbank, alt: "Volksbank" },
    { src: Postbank, alt: "Postbank" },
    { src: DeutscheBank, alt: "DeutscheBank" },
  ],
  fra: [],
};

const BankLogos = () => {
  const { t } = useWebTranslation();
  const logos = bankLogos[getOrg()];

  return logos.length ? (
    <FlexRow justifyContent="flex-end" alignItems="center" wrap>
      {logos.map((bank) => (
        <div key={bank.alt} style={{ marginRight: "5px" }}>
          <Image src={bank.src} height={20} width={20} alt={bank.alt} />
        </div>
      ))}
      <Typography variant="h6" color="grey500">
        {t("payment_methods.trustly_more_banks")}
      </Typography>
    </FlexRow>
  ) : null;
};

export default BankLogos;
